import { types } from '../actions/types';

const initialState = [];

export const noAdInSlot = ( state = initialState, action ) => {
    const newState = [ ...state ];

    switch( action.type ) {
        case types.NO_ADVERT_ON_SLOT: return setNoAdvertOnSlot( newState, action.advert );
        default: return newState;
    }
}

function setNoAdvertOnSlot (newState, advert) {
    return [ ...newState, advert ];
}


// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/reducers/noAdInSlot.js